import React from 'react';

const AISecurityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM14 15H13V17H11V15H10V13H11V12H13V13H14V15ZM14 11H10V9H14V11Z"
      fill="currentColor"
    />
    <path
      d="M18 11.09C18 15.09 15.45 18.79 12 19.92C8.55 18.79 6 15.1 6 11.09V6.39L12 4.14L18 6.39V11.09Z"
      fill="currentColor"
      fillOpacity="0.2"
    />
  </svg>
);

export default AISecurityIcon;
